import Vue from 'vue'
import axios from '@/wrappers/axios.js'

const TagService = {

    getList(params) {
        params = typeof params !== 'undefined'
            ? params
            : '';
        return axios.get('/tags'+params)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },
    createTag(data) {
        return axios.post('/tags',data)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },
    getTag(id,params=null) {
        return axios.get(`/tags/${id}${params}`)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },
    updateTag(id,data) {
        return axios.put(`/tags/${id}`,data)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },
}

Vue.$tagService = TagService

export default TagService